module.exports = __webpack_public_path__ + "img/picovoyage.b956b67c.png";